import React from 'react';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  return <Section id="testimonials" darker data-id="element-174">
      <div className="flex flex-col md:flex-row gap-12 items-start" data-id="element-175">
        {/* Header Side */}
        <div className="md:w-1/3 sticky top-24" data-id="element-176">
          <h2 className="font-display text-5xl md:text-6xl text-white mb-6" data-id="element-177">
            {t.testimonials.title1}
            <br data-id="element-178" />
            <span className="text-brand-accent" data-id="element-179">{t.testimonials.title2}</span>
          </h2>
          <p className="text-gray-400 text-lg mb-8" data-id="element-180">
            {t.testimonials.subtitle}
          </p>
          <div className="flex items-center gap-2" data-id="element-181">
            <div className="flex -space-x-2" data-id="element-182">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-10 h-10 rounded-full bg-gray-700 border-2 border-brand-dark flex items-center justify-center text-xs font-bold text-gray-400" data-id="element-183">
                  User
                </div>)}
            </div>
            <span className="text-white font-bold ml-2" data-id="element-184">
              {t.testimonials.happyClients}
            </span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="md:w-2/3 grid gap-6" data-id="element-185">
          {t.testimonials.items.map((testimonial, index) => <div key={index} className="bg-brand-surface p-8 border-l-4 border-brand-accent relative" data-id="element-186">
              <Quote className="absolute top-4 right-4 w-10 h-10 text-brand-gray opacity-50" data-id="element-187" />
              <p className="text-xl text-gray-200 italic mb-6 relative z-10" data-id="element-188">
                "{testimonial.text}"
              </p>

              <div className="flex items-center justify-between border-t border-white/5 pt-4" data-id="element-189">
                <div data-id="element-190">
                  <h4 className="text-white font-bold text-lg" data-id="element-191">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-500 text-sm" data-id="element-192">{testimonial.role}</p>
                </div>
                <div className="bg-brand-accent/10 text-brand-accent px-3 py-1 rounded text-xs font-bold uppercase tracking-wider" data-id="element-193">
                  {testimonial.result}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}